<template>
  <div>
    <div class="course-result-table mt-8">
      <div class="text-center">
        <v-progress-circular v-if="isViewLoading" indeterminate color="secondary" />
      </div>

      <v-col cols="12" md="6" v-if="campaign.is_continue_bonus" style="padding-top: 0px; padding-left: 0px;">
        <ResultUserInfo :campaignUser="campaignUser"/>
      </v-col>

      <v-data-table
        dense
        v-if="courseResultList.length > 0"
        :headers="courseResultHeaders"
        :items="courseResultList"
        :items-per-page="1000"
        locale="ja-jp"
        hide-default-footer
      >
        <template v-slot:[`item.name`]="{item}">
          {{item.name}}
          <span v-if="item.aggregate_result_info.custom_objective">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-note
                </v-icon>
              </template>
              <span>{{item.aggregate_result_info.custom_objective}}</span>
            </v-tooltip>
          </span>
        </template>
        <template v-slot:[`item.detail`]="{ item }">
          <div style="text-align: center;">
            <v-btn
              @click="openModal(item)"
              dense
              color="info"
              outlined
              class="my-1"
            >
              表示
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.clear_text`]="{ item }">
          {{item.clear_text}}
          <!-- 達成の概念無し -->
          <!-- <span v-if="item.aggregate_result_info.is_completed" class="pink--text font-weight-bold">
            <v-icon color="pink">mdi-seal-variant</v-icon>
            達成
          </span> -->
        </template>
        <template v-slot:[`item.point`]="{ item }">
          <div style="text-align: right;">
            {{item.point}}pt
          </div>
        </template>
        <template v-slot:[`item.average`]="{ item }">
          <div style="text-align: right;">
            <span v-if="item.aggregate_result_info.average !== null">
              {{item.aggregate_result_info.average.toLocaleString()}} {{item.unit}}
            </span>
          </div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div style="text-align: right;">
            <span v-if="item.aggregate_result_info.total !== null">
              {{item.aggregate_result_info.total.toLocaleString()}} {{item.unit}}
            </span>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-toolbar
          flat
          dense
          class="d-flex flex-row-reverse"
        >
          <v-btn
            fab
            small
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <CourseDetailCard :course="selectedCourse"/>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row class="mt-8">
      <!-- 歩数ランキングを非表示にする -->
      <!-- <v-col cols="12" md="4" v-for="targetCourse in this.rankingList" :key="targetCourse.id" width="100%">
        <span class="font-weight-bold">{{targetCourse.name}} 累計ランキング</span>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="blue" v-bind="attrs" v-on="on" style="margin-left:10px">
              mdi-help-circle
            </v-icon>
          </template>
          <span>ランキングは1時間に1回更新されます。(9時から21時)</span>
        </v-tooltip>
        <v-list-item v-for="ranking in targetCourse.rankingData" :key="ranking.id" style="height: 50px; width:368px ; margin:0 auto">
          <v-list-item-icon class="rank-icon">
            <v-icon v-if="ranking.rank === 1" color="gold" large>mdi-crown</v-icon>
            <v-icon v-if="ranking.rank === 2" color="silver" large>mdi-crown</v-icon>
            <v-icon v-if="ranking.rank === 3" color="bronze" large>mdi-crown</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="{'font-weight-black': ranking.isMyData}">
              <div style="width:80px;text-align:center;float:left;">{{ranking.rank}}位</div>
              <div style="width:120px;text-align:right;float:left;">{{ranking.total}} {{targetCourse.unit}}</div>
              <div style="width:70px">
                <v-chip v-if="ranking.isMyData" style="margin-left:16px;" color="primary" small>あなた</v-chip>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!targetCourse.isTop3" style="height: 50px; width:368px; margin:0 auto">
          <v-list-item-icon style="margin:auto 0">
            <v-chip style="margin: 0" color="primary" small>あなた</v-chip>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-black">
              <div style="width:80px;text-align:center;float:left;">{{targetCourse.selfData.rank}}位</div>
              <div style="width:120px;text-align:right;float:left;">{{targetCourse.selfData.total}} {{targetCourse.unit}}</div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col> -->

      <v-col v-for="dataSet in chartDataSetList" :key="dataSet.title" cols="12" md="4" width="100%">
        <span class="font-weight-bold">{{dataSet.title}}</span>
        <line-chart :chartData="dataSet.chartData" :options="dataSet.options" :styles="chartStyle" :height="200"></line-chart>
      </v-col>
    </v-row>

    <v-row v-if="showAppStatusInfo">
      <v-col cols="12" style="margin:auto">
        <AppStatus :appStatus="appEntryStatus"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const CourseDetailCard = () => import('../course/CourseDetailCard')
const LineChart = () => import('./LineChart')
const AppStatus = () => import('../app/AppStatus')
const ResultUserInfo = () => import('./ResultUserInfo')

// const listAggregateResultRankingQuery = (campaignId, courseId) => `
//   query listAggregateResultRanking {
//     listAggregateResultRanking(campaign_id: "${campaignId}", course_id: "${courseId}") {
//       ranking {
//         rank
//         result {
//           total_for_rank
//         }
//       }
//       self_result {
//         rank
//         total_for_rank
//       }
//     }
//   }
// `
// const getAggregateResultRankingList = async (campaignId, courseId) => {
//   const { data: { listAggregateResultRanking: data } } = await GraphqlAPI(listAggregateResultRankingQuery(campaignId, courseId))
//   return data
// }

export default {
  name: 'resultConfirm',
  data () {
    return {
      courseResultList: [],
      selectedCourse: {},
      chartDataSetList: [],
      rankingList: [],
      dialog: false,
      courseResultHeaders: [
        { text: '選択コース', value: 'name', sortable: false, class: 'pl-2 pr-1' },
        { text: 'コースの説明', value: 'detail', sortable: false, class: 'pl-2 pr-1' },
        { text: 'コース達成状況', value: 'clear_text', sortable: false, class: 'pl-2 pr-1' },
        { text: 'ポイント', value: 'point', sortable: false, class: 'pl-2 pr-1' },
        { text: '平均', value: 'average', sortable: false, class: 'pl-2 pr-1' },
        { text: '累計', value: 'total', sortable: false, class: 'pl-2 pr-1' }
      ],
      showAppStatusInfo: false,
      isViewLoading: false
    }
  },
  props: [
    'campaignUser',
    'propsDailyValueList'
  ],
  components: {
    CourseDetailCard,
    LineChart,
    AppStatus,
    ResultUserInfo
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    chartStyle () {
      return {
        height: `${this.height}px`,
        position: 'relative'
      }
    },
    appEntryStatus () {
      return this.$store.getters.getAppEntryStatus
    }
  },
  watch: {
    propsDailyValueList: {
      handler (newValue) {
        if (newValue !== null) {
          this.courseResultListFormatter(newValue)
          this.chartDataFormatter(newValue)
          // this.rankingDataFomatter(newValue)
        }
      },
      deep: true
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    if (this.propsDailyValueList !== null) {
      this.courseResultListFormatter(this.propsDailyValueList)
      this.chartDataFormatter(this.propsDailyValueList)
      // this.rankingDataFomatter(this.propsDailyValueList)
    }

    /**
     * アプリチャレンジステータス表示するか
     * キャンセルステータスの場合、コース変更可能期間後は、ここには表示しない
     */
    if (this.campaign.is_app_challenge) {
      const courseDeletableEnd = dayjs(this.campaign.course_deletable_end, 'YYYY-MM-DD').add(1, 'days')
      const isCourseChangeablePeriod = dayjs() < courseDeletableEnd
      this.showAppStatusInfo = this.appEntryStatus && this.appEntryStatus !== 'Unregistered' && !(!isCourseChangeablePeriod && this.appEntryStatus === 'Canceled')
    }
  },
  methods: {
    // コースごとの達成状況のリストをフォーマットする
    courseResultListFormatter (resultList) {
      this.isViewLoading = true
      this.courseResultList = resultList.select_course_list.map(courseResult => {
        let clearText = null
        if (courseResult.complete_type === 'Daily_CircleAndCross' ||
          courseResult.complete_type === 'Daily_StandardValue'
        ) {
          // 達成の概念無し
          // clearText = courseResult.complete_value + '日中、' +
          clearText = courseResult.aggregate_result_info.clear_count + '日クリア'
        } else if (courseResult.complete_type === 'Weekly_CircleAndCross') {
          // 達成の概念無し
          // clearText = courseResult.complete_value + '週中、' +
          clearText = courseResult.aggregate_result_info.clear_count + '週クリア'
        } else if (courseResult.complete_type === 'UpperLimit') {
          clearText = courseResult.complete_value + '回中、' +
                      courseResult.aggregate_result_info.clear_count + '回クリア'
        }
        return {
          ...courseResult,
          clear_text: clearText,
          point: courseResult.aggregate_result_info.point ? courseResult.aggregate_result_info.point : 0
        }
      })
      this.isViewLoading = false
    },
    // グラフ出力対象コースのデータをフォーマットする
    chartDataFormatter (resultList) {
      this.chartDataSetList = []
      const displayChartCourse = resultList.select_course_list.filter(courseResult => {
        return courseResult.is_display_graph
      })
      displayChartCourse.forEach(targetCourse => {
        const dates = []
        const values = []
        resultList.daily_results.forEach(dailyResult => {
          const splitDate = dailyResult.meta.split('-')
          dates.push(splitDate[1] + '/' + splitDate[2])
          let hasTargetData = false
          dailyResult.select_course_result.forEach(courseResult => {
            if (courseResult.course_id === targetCourse.id) {
              hasTargetData = true
              // 「0」が入力されたデータはプロット対象外とする
              if (targetCourse.result_type === 'Number') {
                values.push((courseResult.number === 0) ? null : courseResult.number)
              } else if (targetCourse.result_type === 'Integer') {
                values.push((courseResult.integer === 0) ? null : courseResult.integer)
              }
            }
          })
          if (!hasTargetData) {
            values.push(null)
          }
        })
        // Chart.jsで出力
        this.chartDataSetList.push({
          title: targetCourse.name,
          chartData: {
            labels: dates,
            datasets: [
              {
                label: targetCourse.name,
                backgroundColor: '#ff6673',
                data: values,
                spanGaps: true
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    // 0から表示する
                    beginAtZero: true,
                    // Y軸の目盛りに小数点を出さないようにする（体重測定無しを前提）
                    userCallback: function (label, index, labels) {
                      if (Math.floor(label) === label) {
                        return label.toString() + targetCourse.unit
                      }
                    }
                  }
                }
              ]
            }
          }
        })
      })
    },
    // コース内ランキング（対象：累計を計算するコース）
    // async rankingDataFomatter (resultList) {
    //   this.rankingList = []
    //   try {
    //     for (const courseResult of resultList.select_course_list) {
    //       if (courseResult.aggregate && courseResult.aggregate.length > 0 && courseResult.aggregate.includes('累計')) {
    //         const rankingData = await getAggregateResultRankingList(this.campaign.id, courseResult.id)
    //         const diplayRanking = []
    //         let isTop3 = false
    //         let flaggedIsMy = false
    //         if (rankingData.ranking.length > 0) {
    //           rankingData.ranking.forEach(ranking => {
    //             diplayRanking.push({
    //               rank: ranking.rank,
    //               total: ranking.result.total_for_rank.toLocaleString(),
    //               isMyData: (rankingData.self_result.rank === ranking.rank) && !flaggedIsMy
    //             })
    //             if (rankingData.self_result.rank === ranking.rank) {
    //               isTop3 = true
    //               flaggedIsMy = true
    //             }
    //           })
    //         }
    //         if (rankingData.self_result.rank && rankingData.self_result.total_for_rank) {
    //           this.rankingList.push({
    //             id: courseResult.id,
    //             name: courseResult.name,
    //             unit: courseResult.unit,
    //             rankingData: diplayRanking,
    //             selfData: {
    //               rank: rankingData.self_result.rank,
    //               total: rankingData.self_result.total_for_rank.toLocaleString()
    //             },
    //             isTop3: isTop3
    //           })
    //         }
    //       }
    //     }
    //   } catch (e) {
    //     this.$emit('errorHandling', 'コースランキングの取得に失敗しました。' + e.errors[0].message)
    //     this.$log.debug(e)
    //   }
    // },
    openModal (courseResult) {
      this.selectedCourse = courseResult
      this.dialog = true
    }
  }
}
</script>

<style scoped lang="scss">
.rank-icon {
  margin: 7px 12px !important;
}
.course-result-table > .v-data-table ::v-deep th {
  border-right: 1px solid #c4c4c4 !important;
  background-color: #FFF8E1 !important;
  text-align: center !important;
}
.course-result-table > .v-data-table ::v-deep td {
  padding-left: 8px !important;
  padding-right: 4px !important;
  font-size: 0.8rem !important;
  border-right: 1px solid #c4c4c4 !important;
}
.course-result-table > .v-data-table ::v-deep div.v-data-table__wrapper {
  border: 1px solid #c4c4c4 !important;
  border-right: 0px !important;
}
</style>
